module.exports = __webpack_public_path__ + "img/horizontal_3_3_8023.dde7da77.png";